import { initContract } from "@ts-rest/core";

import { ContactsSortRulesType } from "@src/resources/admin/admin.service";

const c = initContract();

const index = c.router({
  getContactRules: {
    method: "GET",
    path: "/admin/contact-rules",
    responses: {
      200: c.type<ContactsSortRulesType>(),
    },
  },
  updateContactRules: {
    body: c.type<ContactsSortRulesType>(),
    method: "PUT",
    path: "/admin/contact-rules",
    responses: {
      200: c.type<ContactsSortRulesType>(),
    },
  },
});

export default index;
